module.exports = __webpack_public_path__ + "static/img/login-box-bg.2a94cc06.png";